import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useHomeSmartOffer, eventQuery } from '../../components/home-smart/useHomeSmartOffer';
import { HomeSmartOfferNotice, HomeSmartOfferLoading } from '../../components/home-smart/HomeSmartOfferNotice';
import { HomeSmartEventAnalytics } from '../../components/home-smart/HomeSmartEventAnalytics';
import { HomeSmartHeaderHero } from '../../components/home-smart/HomeSmartHeaderHero';
import { HomeSmartProblemSolution } from '../../components/home-smart/HomeSmartProblemSolution';
import { HomeSmartWorkflow } from '../../components/home-smart/HomeSmartWorkflow';
import { HomeSmartAudienceFeatures } from '../../components/home-smart/HomeSmartAudienceFeatures';
import { HomeSmartPricingCalculator } from '../../components/home-smart/HomeSmartPricingCalculator';
import { HomeSmartTrialFooter } from '../../components/home-smart/HomeSmartTrialFooter';

export default function HomeSmartLanding() {
  const context = useHomeSmartOffer();
  const { code } = useParams();
  if (context.loading || context.error) return <HomeSmartOfferLoading error={context.error} refresh={context.refresh}/>;
  if (code && context.offer.status !== 'active') return <Navigate replace to={`/home-smart${eventQuery(code)}`}/>;
  const months = context.offer.trial_months;
  return (
    <div className="min-h-screen overflow-x-hidden bg-white text-[#0a2c5c]" style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }} data-testid="home-smart-landing">
      <HomeSmartHeaderHero trialMonths={months} registrationPath={context.registrationPath} loginPath={`/home-smart/accedi${eventQuery(context.code)}`}/>
      <HomeSmartOfferNotice offer={context.offer} popup/>
      {context.offer.event_id && <HomeSmartEventAnalytics code={context.code}/>}
      <HomeSmartProblemSolution registrationPath={context.registrationPath}/>
      <HomeSmartWorkflow />
      <HomeSmartAudienceFeatures registrationPath={context.registrationPath}/>
      <HomeSmartPricingCalculator trialMonths={months}/>
      <HomeSmartTrialFooter registrationPath={context.registrationPath}/>
    </div>
  );
}